import {injectable} from "inversify";
import {ISentryAdapter} from "@intelingu/core/stores/adapters/ISentryAdapter";
import * as Sentry from '@sentry/browser';

@injectable()
export class SentryAdapter implements ISentryAdapter {

    captureMessage(message: string, options) {
        if (options && options.scope) {
            Sentry.withScope(scope => {
                options.scope(scope)
                Sentry.captureMessage(message)
            });
        }
        Sentry.captureMessage(message);
    }

}
